import * as React from 'react';
import { StepText } from '../common/StepText';
import { Step } from '../common/Step';

export class CompleteStep extends React.Component {
  render() {
    return (
      <Step id="complete-step">
        <StepText>ご予約が完了しました。</StepText>
      </Step>
    );
  }
}
